/**
 * Format a Date in local time as yyyy/mm/dd HH:mm:ss (24-hour).
 *
 * Used for rendering `.utc-datetime[data-utc]` spans consistently across pages.
 */
export function formatLocalDatetime(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "-";
  }

  const pad = (value) => String(value).padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  return `${year}/${month}/${day} ${pad(date.getHours())}:${pad(
    date.getMinutes(),
  )}:${pad(date.getSeconds())}`;
}

export function initUtcDatetimes(root) {
  (root || document)
    .querySelectorAll(".utc-datetime[data-utc]")
    .forEach(function (el) {
      if (el.getAttribute("data-kt-initialized") === "1") return;
      el.setAttribute("data-kt-initialized", "1");

      var utcString = el.getAttribute("data-utc");
      if (!utcString) {
        el.textContent = "-";
        return;
      }
      el.textContent = formatLocalDatetime(new Date(utcString));
    });
}
